import { KedeDebtStatusEnum } from "../../enums/statusEnums";

export const debtColumns = [
	{ field: "id", headerName: "ID" },
	{ field: "m06_id", headerName: "ID Συνδρομής" },
	{ field: "afm", headerName: "ΑΦΜ" },
	{ field: "fiscal_year", headerName: "Οικονομικό Έτος" },
	{
		field: "status",
		headerName: "Κατάσταση",
		enum: KedeDebtStatusEnum,
	},
	{ field: "amount", headerName: "Αρχικό Χρέος" },
	{ field: "rest_amount", headerName: "Εναπομείναν Χρέος" },
	{ field: "registryUrl", headerName: "Αριθμός Γ.Ε.ΜΗ." },
	{ field: "sent_to_payProgress", headerName: "Τελευταία Ενημέρωση απο ΑΑΔΕ" },
];

export const kedeDebtDiscountColumns = [
	{ field: "id", headerName: "ID" },
	{ field: "discount_amount", headerName: "Ποσό Έκπτωσης" },
	{ field: "date_created", headerName: "Ημερομηνία Δημιουργίας" },
];
